import parse from "html-react-parser";
import Link from "next/link";
import React from "react";

type Props = {
  locationName: string;
  brandList: string[];
  url: string;
  title?: string;
};

const AvailableBrands = (props: Props) => {
  const length = props.brandList.length;
  const [slice, setSlice] = React.useState(6);

  const brandNameToImg = (name: string) => {
    let brandName = name.toLowerCase();
    switch (brandName) {
      case "land":
        brandName = "land-rover";
      case "alfa":
        brandName = "alfa-romeo";
      case "bmw":
        return `/cars/bmw.png`;
    }

    return `https://raw.githubusercontent.com/filippofilip95/car-logos-dataset/master/logos/optimized/${brandName}.png`;
  };
  return (
    <div className="mt-5 lg:mt-[60px] bg-white py-[30px]">
      <div className="mx-auto max-w-7xl px-[16px]">
        <div className="w-full">
          <div className=" mb-[18px] flex justify-between items-center">
            <h2 className="text-base font-bold lg:text-3xl text-my-dark-blue">
              {props.title
                ? props.title
                : `Rental Car Brands available in ${props.locationName}`}
            </h2>
          </div>
          <div
            className="pb-8 space-y-6 text-sm font-normal lg:pb-0 text-my-light-blue lg:font-light lg:text-base"
          >
            {parse(`<p>
            Rental car companies at ${
              props.locationName
            } offer users a wide range of car brands. Whether you are looking for ${props.brandList
              .slice(0, 6)
              .map((item): string => item)
              .join(", ")
              .replace(/, ([^,]*)$/, " or $1")}, you can find one at  ${
              props.locationName
            }.`)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-[14px] py-4 mt-[18px] lg:grid-cols-6 md:grid-cols-4">
          {props.brandList.slice(0, slice).map((brand) => (
            <Link
              href={`/${props.url}/brand/${brand.toLowerCase()}`}
              className="flex relative flex-col items-center justify-center transition-all bg-white border border-[#E5EAF6] hover:scale-105 aspect-[224/154] rounded-[22px] shadow-custom group"
              key={brand}
            >
              <img
                loading="lazy"
                alt={`Rent ${brand.toLowerCase()} cars`}
                src={brandNameToImg(brand)}
                className={`max-w-[90px] max-h-[90px] group-hover:scale-[1.15] transition-all group-hover:opacity-[0.1] filter group-hover:grayscale`}
              />
              <div className="absolute bottom-0 w-full h-full mt-2 text-center font-bold text-black transition-all rounded-[22px] opacity-0 font-lg group-hover:opacity-100 flex items-center justify-center flex-col">
                <p className="transition-all group-hover:text-xl text-shadow">
                  {brand}
                </p>
              </div>
            </Link>
          ))}
        </div>
        <div className="flex justify-end w-full">
          {length > 6 && (
            <button
              className="pr-3 text-sm font-semibold text-my-dark-blue hover:underline"
              onClick={() => setSlice(slice === length ? 6 : length)}
            >
              {`Show ${slice === length ? "Less" : "More"}`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AvailableBrands;
